import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SharedModule } from '@shared/shared.module';
import { MultiLanguageModule } from '@/app/multi-language.module';

/** `chunk`: een onderdeel dat de gebruiker opende, kan de oude build niet meer laden. */
export type AppUpdateReason = 'update' | 'chunk';

export interface AppUpdateDialogData {
  reason: AppUpdateReason;
  currentVersion: string;
  /** Versie van de klaarstaande build; ontbreekt wanneer die niet bekend is. */
  newVersion?: string;
}

/**
 * "Nieuwe versie beschikbaar" in de huidige dialoogstijl (e-dialog-container-shell, panel-
 * klasse `e-dialog-panel`): sluit met `true` om te herstarten, met `false` of `undefined`
 * (sluitknop, Escape, backdrop) voor later. Het herstarten zelf doet AppUpdateService.
 */
@Component({
  selector: 'egi-app-update-dialog',
  imports: [SharedModule, MultiLanguageModule],
  templateUrl: './app-update-dialog.component.html',
  styleUrl: './app-update-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppUpdateDialogComponent {
  protected readonly dialogRef = inject<MatDialogRef<AppUpdateDialogComponent, boolean>>(MatDialogRef);
  protected readonly data = inject<AppUpdateDialogData>(MAT_DIALOG_DATA);
}
